'use client';
import BranchComponent from './BranchComponent';
import FeaturedCategoryComponent from './FeaturedCategoryComponent';
import LevelComponent from './LevelComponent';
import LocationComponent from './LocationComponent';
import PostDateComponent from './PostDateComponent';
import SalaryComponent from './SalaryComponent';
import TimeTypeComponent from './TimeTypeComponent';

const LeftSidebarComponent = () => {
  return (
    <div className="px-4 bg-white rounded-xl">
      <BranchComponent />
      <SalaryComponent />
      <PostDateComponent />
      <LevelComponent />
      <TimeTypeComponent />
      <LocationComponent />
      <FeaturedCategoryComponent />
    </div>
  );
};

export default LeftSidebarComponent;
